import React, { useEffect } from 'react';
import * as styles from './Modal.module.css';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  disableBackdropClick?: boolean;
  disableEscapeClose?: boolean;
  children: React.ReactNode;
}

function Modal({
  open,
  onClose,
  disableBackdropClick = false,
  disableEscapeClose = false,
  children,
}: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !disableEscapeClose) onClose();
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [open, onClose, disableEscapeClose]);

  if (!open) return null;

  return (
    <div
      className={styles.overlay}
      onClick={disableBackdropClick ? undefined : onClose}
    >
      <div className={styles.box} onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}

export default Modal;
